import { render } from "./ContractorView.vue?vue&type=template&id=70a1d89c&scoped=true"
import script from "./ContractorView.vue?vue&type=script&lang=js"
export * from "./ContractorView.vue?vue&type=script&lang=js"

import "./ContractorView.vue?vue&type=style&index=0&id=70a1d89c&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\hesabtech-live\\hesabtech-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70a1d89c"]])

export default __exports__